import React from 'react';
import { Card, Collapse } from '@duxton-web/ui';

import RolloutDiff from '../RolloutDiff';
import ChangelogCollapseTitle from './ChangelogCollapseTitle';
import ChangelogInfoHeader from './ChangelogInfoHeader';
import { ChangelogType } from '@/common/const';
import {
  Changelog,
  ModifiedRolloutTargetMapValue,
} from '@/common/dto/changelog';
import VariableDiff from '@/features/changelog/variable-diff';
import { Rollout } from '@/lib/PlannerDTOs';

interface OwnProps {
  changelog: Changelog;
  latestRollout?: Rollout;
  modifiedRolloutTargets: Map<string, ModifiedRolloutTargetMapValue>;
  onRestore?: (rollout: Rollout) => void;
}

function ChangelogMainContent({ changelog, modifiedRolloutTargets }) {
  switch (changelog?.changelog_type) {
    case ChangelogType.ROLLOUT:
      return (
        <RolloutDiff
          data-testid="changelog-wrapper-rollout-diff"
          rolloutTargets={modifiedRolloutTargets}
          changelog={changelog}
        />
      );
    case ChangelogType.VARIABLE:
      return <VariableDiff changelog={changelog} />;
    default:
      return <></>;
  }
}

function ChangeLogItemDetails({
  changelog,
  latestRollout,
  modifiedRolloutTargets,
  onRestore,
}) {
  return (
    <Collapse
      className="changelog-changes-container"
      expandIconPosition="end"
      items={[
        {
          label: (
            <ChangelogCollapseTitle
              changelog={changelog}
              latestRollout={latestRollout}
              modifiedRolloutTargets={modifiedRolloutTargets}
              onRestore={onRestore}
            />
          ),
          children: (
            <ChangelogMainContent
              changelog={changelog}
              modifiedRolloutTargets={modifiedRolloutTargets}
            />
          ),
        },
      ]}
    />
  );
}

export default function ChangelogWrapper({
  changelog,
  latestRollout,
  modifiedRolloutTargets,
  onRestore,
}: OwnProps) {
  return (
    <div>
      <Card
        style={{
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
        }}
        styles={{
          body: {
            padding: 16,
          },
        }}
      >
        <ChangelogInfoHeader changelog={changelog} />
      </Card>
      <ChangeLogItemDetails
        changelog={changelog}
        latestRollout={latestRollout}
        modifiedRolloutTargets={modifiedRolloutTargets}
        onRestore={onRestore}
      />
    </div>
  );
}
